import type { FireBaseTimestamp } from 'tradera/apps/tradera/messaging/types';

function timestampToDate(firebaseTimestamp: FireBaseTimestamp): Date {
    const seconds =
        firebaseTimestamp._seconds ?? firebaseTimestamp.seconds ?? 0;
    const nanoseconds =
        firebaseTimestamp._nanoseconds ?? firebaseTimestamp.nanoseconds ?? 0;
    return new Date(seconds * 1000 + nanoseconds / 1000000);
}

export { timestampToDate };
